import { Dispatch } from 'redux'
import { PaansIntegrationService } from 'services/paansIntegration.service';

export const getPolicyAction: any = (payload: any) => async (dispatch: Dispatch, getState: any) => {
    try {
        const state = getState()?.paansIntegration;
        const loading = state?.loading;
        const alreadyChecked = state?.checkPolicyAccepted;
        if (loading || alreadyChecked) {
            return;
        }
        dispatch({ type: 'GET_POLICY_STARTED' });
        const res = await PaansIntegrationService.getPolicy(payload);
        if(!res) {
            dispatch({ type: 'GET_POLICY_ERROR', payload: 'Error getting policy' });
        }
        const value = res?.value as { data: any };
        const payloadData = {
            fileUrl: value.data?.fileUrl,
            isPolicyAccepted: value.data?.hasAccepted,
            checkPolicyAccepted: true,
        }
        dispatch({
            type: 'GET_POLICY_COMPLETED',
            payload: payloadData
        });
    } catch(e) {
        dispatch({ type: 'GET_POLICY_ERROR', payload: 'Error getting policy' });
    }
}

export const acceptPolicyAction: any = (payload: any) => async (dispatch: Dispatch) => {
    try {
        dispatch({ type: 'ACCEPT_POLICY_STARTED' });
        const res = await PaansIntegrationService.acceptPolicy(payload);
        if(!res) {
            dispatch({ type: 'ACCEPT_POLICY_ERROR' });
            throw new Error('Error accepting policy');
        }
        const value = res?.value as { data: any };
          const payloadData = {
            isPolicyAccepted: value.data?.hasAccepted,
        }
        dispatch({ type: 'ACCEPT_POLICY_COMPLETED', payload: payloadData });
    } catch(e) {
        dispatch({ type: 'ACCEPT_POLICY_ERROR' });
        throw new Error('Error accepting policy');
    }
}

export const resetPolicyError: any = () => (dispatch: Dispatch) => {
    dispatch({ type: 'RESET_POLICY_ERROR' });
}
